/**
  * Vue DevExtreme localisation.
  * Active locale is changed in AppLocalisationMixin, where the i18n message files are loaded.
  **/
import {
    locale as dxLocale,
    loadMessages as dxLoadMessages
} from 'devextreme/localization';

import(/* webpackPreload: true, webpackChunkName: "dx" */'assets/styles/dx.material.blue-custom.css');
import(/* webpackPreload: true, webpackChunkName: "dx" */'assets/styles/dx-overrides.scss');

export const plugin = {
    name: 'dx-localization',

    install (Vue, params) {
        window.dxLocale = dxLocale;
        window.dxLoadMessages = dxLoadMessages;

        // dxLoadMessages(fiMessages);
        // dxLoadMessages(svMessages);

        // set initial locale
        const { store } = params;
        const locale = store.getters['ux/getLocale'];
        dxLocale(locale);

        // additional translations
        dxLoadMessages({
            fi: {
                "dxHtmlEditor-bold": "Lihavoi",
                "dxHtmlEditor-italic": "Kursivoi",
                "dxHtmlEditor-underline": "Alleviivaa",
                "dxHtmlEditor-size": "Koko",
                "dxHtmlEditor-font": "Fontti",
                "dxHtmlEditor-alignLeft": "Tasaus vasemmalle",
                "dxHtmlEditor-alignCenter": "Keskitä",
                "dxHtmlEditor-alignRight": "Tasaus oikealle",
                "dxHtmlEditor-alignJustify": "Tasattu",
                "dxHtmlEditor-blockquote": "Lohkolainaus",
                "dxHtmlEditor-link": "Linkki",
                "dxHtmlEditor-orderedList": "Numeroitu lista",
                "dxHtmlEditor-bulletList": "Luettelo"
            },
            sv: {
                "dxHtmlEditor-bold": "Fet",
                "dxHtmlEditor-italic": "Kursiv",
                "dxHtmlEditor-underline": "Understruken",
                "dxHtmlEditor-size": "Storlek",
                "dxHtmlEditor-font": "Tecken",
                "dxHtmlEditor-alignLeft": "Vänsterjustera",
                "dxHtmlEditor-alignCenter": "Centrera",
                "dxHtmlEditor-alignRight": "Högerjusterat",
                "dxHtmlEditor-alignJustify": "Marginaljustering",
                "dxHtmlEditor-blockquote": "Block citat",
                "dxHtmlEditor-link": "Länk",
                "dxHtmlEditor-orderedList": "Numrerad lista",
                "dxHtmlEditor-bulletList": "Punktlista"
            }
        });
    }
};

export default plugin;
